export default __webpack_public_path__ + "static/media/destiny-banner.9072d618.png";